import { render, staticRenderFns } from "./RazaoHierarquicoReport.vue?vue&type=template&id=c80d01da&scoped=true"
import script from "./RazaoHierarquicoReport.vue?vue&type=script&lang=js"
export * from "./RazaoHierarquicoReport.vue?vue&type=script&lang=js"
import style0 from "./RazaoHierarquicoReport.vue?vue&type=style&index=0&id=c80d01da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80d01da",
  null
  
)

export default component.exports